import { BookOpen, Download, FileText, Mail } from "lucide-react";
import { BOOK, IMAGES, INSIDE_ITEMS } from "../content";
import { Reveal } from "./Reveal";

const InsideArchive = () => (
  <section className="py-20 lg:py-32 bg-[#06333E] border-y border-[#D4AF37]/10" data-testid="inside-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-mono-alt text-xs uppercase tracking-[0.35em] text-[#D4AF37]">What's inside</p>
        <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#F8FAFC] max-w-2xl leading-tight">
          One archive. Four movements.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-8 lg:grid-cols-12 gap-6">
        <Reveal className="md:col-span-8 lg:col-span-7">
          <div className="grid sm:grid-cols-2 gap-6 h-full">
            {INSIDE_ITEMS.map((c, i) => (
              <div
                key={c.number}
                data-testid={`chapter-card-${i}`}
                className="group rounded-lg border border-[#D4AF37]/15 bg-[#052730] p-8 transition-all duration-500 hover:border-[#D4AF37]/45 hover:-translate-y-1"
              >
                <p className="font-display text-4xl font-bold text-outline group-hover:text-[#D4AF37] transition-colors duration-500" style={{ WebkitTextStroke: undefined }}>
                  {c.number}
                </p>
                <h3 className="mt-4 font-display text-xl font-semibold text-[#F8FAFC]">{c.name}</h3>
                <p className="mt-1 font-mono-alt text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]/60">{c.pages}</p>
                <p className="mt-3 text-sm text-[#94A3B8] leading-relaxed">{c.desc}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15} className="md:col-span-8 lg:col-span-5">
          <div className="relative h-full min-h-[24rem] rounded-lg overflow-hidden border border-[#D4AF37]/20" data-testid="parchment-card">
            <img src={IMAGES.parchment} alt="Aged parchment manuscript texture" className="absolute inset-0 w-full h-full object-cover opacity-40" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#052730] via-[#052730]/60 to-transparent" />
            <div className="relative h-full flex flex-col justify-end p-8">
              <p className="font-serif-alt italic text-2xl text-[#F8FAFC] leading-relaxed">
                "The problem is no longer: can we access information? It is: what are we capable of recognising?"
              </p>
              <p className="mt-4 font-mono-alt text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]">Chapter II · p. 53</p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.2} className="md:col-span-8 lg:col-span-12">
          <div className="grid sm:grid-cols-3 gap-6">
            {[
              { icon: FileText, label: `${BOOK.pages} pages · ${BOOK.chapters} chapters + archive notes`, testid: "stat-pages" },
              { icon: Download, label: "Instant PDF download after checkout", testid: "stat-download" },
              { icon: Mail, label: "Personal download link sent to your email", testid: "stat-email" },
            ].map(({ icon: Icon, label, testid }) => (
              <div key={testid} data-testid={testid} className="flex items-center gap-4 rounded-lg border border-[#D4AF37]/15 bg-[#052730] p-6">
                <span className="w-11 h-11 rounded-full border border-[#D4AF37]/30 flex items-center justify-center shrink-0">
                  <Icon className="w-5 h-5 text-[#D4AF37]" />
                </span>
                <p className="text-sm text-[#F8FAFC]/85">{label}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.25} className="md:col-span-8 lg:col-span-12">
          <div className="flex items-center gap-3 text-xs text-[#94A3B8]">
            <BookOpen className="w-4 h-4 text-[#D4AF37]" />
            <span>Reads beautifully on phone, tablet, e-reader, and desktop — no app required.</span>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default InsideArchive;
